<template>
  <v-main class="tpadding" style="padding-top: 0px">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-data-table
                class="custom-header-color text-center elevation-2"
                :headers="headers"
                :items="firstTableItems"
                :loading="loading"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:[`header.horaSalida`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-clock-outline</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.ruta`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-map-marker</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.vehiculo`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-bus-side</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.planta`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-office-building</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.estadoUnidad`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-traffic-light</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.tiempoParaSalir`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-pulse</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`item.horaSalida`]="{ item }">
                  <div style="white-space: pre-line; text-align: center">
                    <div style="font-weight: bold; font-size: 1.2em">{{ getHora(item.horaSalida) }}</div>
                    <div style="font-size: 0.9em">{{ getFecha(item.horaSalida) }}</div>
                  </div>
                </template>
                <template v-slot:[`item.ruta`]="{ item }">
                  <div style="white-space: pre-line; text-align: left; padding-bottom: 8px">
                    <div style="font-weight: bold; font-size: 1.2em">
                      {{ item.ruta }}
                    </div>
                    <div
                      class="d-inline-flex align-center"
                      :style="{
                        backgroundColor:
                          item.estadoUnidad === 'EN_SITIO'
                            ? '#4CAF50' // Verde
                            : item.estadoUnidad === 'POR_ARRIBAR'
                            ? '#A68D38' // Amarillo
                            : '#2196F3', // Azul
                        color: 'black,',
                        borderRadius: '9999px',
                        padding: '4px 10px',
                        fontSize: '0.85em',
                        gap: '6px',
                        whiteSpace: 'nowrap',
                        fontWeight: 'bold'
                      }"
                    >
                      <v-icon small color="black">
                        {{
                          item.estadoUnidad === 'EN_SITIO'
                            ? 'mdi-map-marker-check'
                            : item.estadoUnidad === 'POR_ARRIBAR'
                            ? 'mdi-timer-sand'
                            : 'mdi-truck-fast'
                        }}
                      </v-icon>
                      <span style="color: black; font-size: 1.1em">
                        {{
                          item.estadoUnidad === 'EN_SITIO'
                            ? 'En sitio'
                            : item.estadoUnidad === 'POR_ARRIBAR'
                            ? 'Por arribar'
                            : 'En ruta'
                        }}
                      </span>
                    </div>
                  </div>
                </template>

                <template v-slot:[`item.vehiculo`]="{ item }">
                  <div style="white-space: pre-line; text-align: center; padding-top: 8px">
                    <div
                      style="
                        display: inline-block;
                        padding: 4px 12px;
                        background-color: #e3f2fd;
                        color: black;
                        font-weight: bold;
                        font-size: 1.2em;
                        border-radius: 9999px;
                        line-height: 1.4;
                        letter-spacing: 2px;
                      "
                    >
                      {{ item.vehiculo }}
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.tiempoParaSalir`]="{ item }">
                  <div
                    class="d-inline-flex align-center"
                    :class="{ 'glow-en-ruta': true }"
                    :style="{
                      backgroundColor:
                        item.tiempoParaSalir === 'En ruta'
                          ? '#4CAF50'
                          : item.tiempoParaSalir === 'Por salir'
                          ? '#ec942c'
                          : '#64B5F6',
                      color: '#000000',
                      borderRadius: '9999px',
                      padding: '4px 10px',
                      fontSize: '0.85em',
                      gap: '6px',
                      whiteSpace: 'nowrap'
                    }"
                  >
                    <v-icon small color="black">
                      {{ item.tiempoParaSalir === 'En ruta' ? 'mdi-bus' : 'mdi-calendar' }}
                    </v-icon>
                    <span style="color: black; font-size: 1.1em">{{ item.tiempoParaSalir }}</span>
                  </div>
                </template>
                <template v-slot:[`item.estadoUnidad`]="{ item }">
                  <div
                    class="d-inline-flex align-center"
                    :style="{
                      backgroundColor:
                        item.estadoUnidad === 'EN_SITIO'
                          ? '#4CAF50' // Verde
                          : item.estadoUnidad === 'POR_ARRIBAR'
                          ? '#A68D38' // Amarillo
                          : '#2196F3', // Azul
                      color: '#000000,',
                      borderRadius: '9999px',
                      padding: '4px 10px',
                      fontSize: '0.85em',
                      gap: '6px',
                      whiteSpace: 'nowrap',
                      fontWeight: 'bold'
                    }"
                  >
                    <v-icon small color="white">
                      {{
                        item.estadoUnidad === 'EN_SITIO'
                          ? 'mdi-map-marker-check'
                          : item.estadoUnidad === 'POR_ARRIBAR'
                          ? 'mdi-timer-sand'
                          : 'mdi-truck-fast'
                      }}
                    </v-icon>
                    <span style="color: white; font-size: 1.1em">
                      {{
                        item.estadoUnidad === 'EN_SITIO'
                          ? 'En sitio'
                          : item.estadoUnidad === 'POR_ARRIBAR'
                          ? 'Por arribar'
                          : 'En ruta'
                      }}
                    </span>
                  </div>
                </template>

                <template v-slot:[`item.planta`]="{ item }">
                  <div style="color: #8e24aa; font-size: 1.1em; white-space: pre-line">
                    <div>{{ item.nombrePlanta }}</div>
                    <!-- <div v-if="item.planta !== null">{{ item.planta }}</div> -->
                  </div>
                </template>
                <template v-slot:no-data>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      height: 400px;
                      text-align: center;
                      font-size: 1.4rem;
                      font-weight: bold;
                      color: #666;
                    "
                  >
                    No hay salidas programadas en los próximos minutos
                  </div>
                </template>
                <template v-slot:no-results> No se obtuvieron resultados </template>
              </v-data-table>
            </v-col>

            <v-col cols="12" md="6">
              <v-data-table
                class="custom-header-color text-center elevation-2"
                :headers="headers"
                :items="secondTableItems"
                :loading="loading"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:[`header.horaSalida`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-clock-outline</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.ruta`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-map-marker</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.vehiculo`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-bus-side</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.estadoUnidad`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-traffic-light</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`header.tiempoParaSalir`]="{ header }">
                  <v-icon small class="mr-1" color="white">mdi-pulse</v-icon>
                  <span>{{ header.text }}</span>
                </template>
                <template v-slot:[`item.horaSalida`]="{ item }">
                  <div style="white-space: pre-line; text-align: center">
                    <div style="font-weight: bold; font-size: 1.2em">{{ getHora(item.horaSalida) }}</div>
                    <div style="font-size: 0.9em">{{ getFecha(item.horaSalida) }}</div>
                  </div>
                </template>
                <template v-slot:[`item.ruta`]="{ item }">
                  <div style="white-space: pre-line; text-align: left; padding-bottom: 8px">
                    <div style="font-weight: bold; font-size: 1.2em">
                      {{ item.ruta }}
                    </div>
                    <div
                      class="d-inline-flex align-center"
                      :style="{
                        backgroundColor:
                          item.estadoUnidad === 'EN_SITIO'
                            ? '#4CAF50' // Verde
                            : item.estadoUnidad === 'POR_ARRIBAR'
                            ? '#A68D38' // Amarillo
                            : '#2196F3', // Azul
                        color: 'black',
                        borderRadius: '9999px',
                        padding: '4px 10px',
                        fontSize: '0.85em',
                        gap: '6px',
                        whiteSpace: 'nowrap',
                        fontWeight: 'bold'
                      }"
                    >
                      <v-icon small color="black">
                        {{
                          item.estadoUnidad === 'EN_SITIO'
                            ? 'mdi-map-marker-check'
                            : item.estadoUnidad === 'POR_ARRIBAR'
                            ? 'mdi-timer-sand'
                            : 'mdi-truck-fast'
                        }}
                      </v-icon>
                      <span style="color: black; font-size: 1.1em">
                        {{
                          item.estadoUnidad === 'EN_SITIO'
                            ? 'En sitio'
                            : item.estadoUnidad === 'POR_ARRIBAR'
                            ? 'Por arribar'
                            : 'En ruta'
                        }}
                      </span>
                    </div>
                  </div>
                </template>

                <template v-slot:[`item.vehiculo`]="{ item }">
                  <div style="white-space: pre-line; text-align: center; padding-top: 8px">
                    <div
                      style="
                        display: inline-block;
                        padding: 4px 12px;
                        background-color: #e3f2fd;
                        color: black;
                        font-weight: bold;
                        font-size: 1.2em;
                        border-radius: 9999px;
                        line-height: 1.4;
                        letter-spacing: 2px;
                      "
                    >
                      {{ item.vehiculo }}
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.tiempoParaSalir`]="{ item }">
                  <div
                    class="d-inline-flex align-center"
                    :class="{ 'glow-en-ruta': true }"
                    :style="{
                      backgroundColor:
                        item.tiempoParaSalir === 'En ruta'
                          ? '#4CAF50'
                          : item.tiempoParaSalir === 'Por salir'
                          ? '#ec942c'
                          : '#64B5F6',
                      color: '#000000',
                      borderRadius: '9999px',
                      padding: '4px 10px',
                      fontSize: '0.85em',
                      gap: '6px',
                      whiteSpace: 'nowrap'
                    }"
                  >
                    <v-icon small color="black">
                      {{ item.tiempoParaSalir === 'En ruta' ? 'mdi-bus' : 'mdi-calendar' }}
                    </v-icon>
                    <span style="color: black; font-size: 1.1em">{{ item.tiempoParaSalir }}</span>
                  </div>
                </template>
                <template v-slot:[`item.estadoUnidad`]="{ item }">
                  <div
                    class="d-inline-flex align-center"
                    :style="{
                      backgroundColor:
                        item.estadoUnidad === 'EN_SITIO'
                          ? '#4CAF50' // Verde
                          : item.estadoUnidad === 'POR_ARRIBAR'
                          ? '#A68D38' // Amarillo
                          : '#2196F3', // Azul
                      color: '#000000,',
                      borderRadius: '9999px',
                      padding: '4px 10px',
                      fontSize: '0.85em',
                      gap: '6px',
                      whiteSpace: 'nowrap',
                      fontWeight: 'bold'
                    }"
                  >
                    <v-icon small color="white">
                      {{
                        item.estadoUnidad === 'EN_SITIO'
                          ? 'mdi-map-marker-check'
                          : item.estadoUnidad === 'POR_ARRIBAR'
                          ? 'mdi-timer-sand'
                          : 'mdi-truck-fast'
                      }}
                    </v-icon>
                    <span style="color: white; font-size: 1.1em">
                      {{
                        item.estadoUnidad === 'EN_SITIO'
                          ? 'En sitio'
                          : item.estadoUnidad === 'POR_ARRIBAR'
                          ? 'Por arribar'
                          : 'En ruta'
                      }}
                    </span>
                  </div>
                </template>

                <template v-slot:[`item.planta`]="{ item }">
                  <div style="color: #8e24aa; font-size: 1.1em; white-space: pre-line">
                    <div>{{ item.nombrePlanta }}</div>
                    <!-- <div v-if="item.planta !== null">{{ item.planta }}</div> -->
                  </div>
                </template>
                <template v-slot:no-data>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      height: 400px;
                      text-align: center;
                      font-size: 1.4rem;
                      font-weight: bold;
                      color: #666;
                    "
                  >
                    No hay salidas programadas en los próximos minutos
                  </div>
                </template>

                <template v-slot:no-results> No se obtuvieron resultados </template>
              </v-data-table>
            </v-col>
          </v-row>
          <div class="text-center mt-4 font-weight-medium">
            Página {{ currentPage }} de {{ totalPages }} &bull; Mostrando {{ displayedItems }} de
            {{ items.length }} viajes &bull; Actualización cada {{ intervaloTexto }} &bull; Cambio de Pagina cada
            {{ intervaloPaginaTexto }}
          </div>
        </v-card-text>
      </v-card>

      <v-btn v-if="!isClienteDeparturesAuth" fab small bottom right fixed class="v-btn--example">
        <v-icon @click="show = true">mdi-cog</v-icon>
      </v-btn>

      <template>
        <v-dialog v-model="show" max-width="1000px">
          <v-card style="display: flex; flex-direction: column; height: 90vh">
            <!-- Header -->
            <v-card-title class="headline font-weight-bold">
              <v-icon left class="mr-2">mdi-filter</v-icon>
              Configuración y Filtros
              <v-spacer></v-spacer>
              <v-btn icon @click="show = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider class="my-2" />

            <!-- Scrollable Content -->
            <div style="overflow-y: auto; padding: 24px; flex: 1">
              <v-container>
                <v-row>
                  <!-- Columna 1 -->
                  <v-col cols="12" md="6">
                    <!-- Clientes -->
                    <v-row class="align-center mb-1">
                      <v-icon class="mr-2">mdi-account</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1">Clientes</v-subheader>
                    </v-row>
                    <div
                      class="mt-n2"
                      style="
                        max-height: 250px;
                        overflow-y: auto;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        padding: 8px;
                      "
                    >
                      <v-checkbox
                        v-for="c in clientes"
                        :key="c.idcliente_externo"
                        :value="c"
                        v-model="filtros.clientes"
                        dense
                        hide-details
                      >
                        <template v-slot:label>
                          <span :style="{ fontWeight: c.nombre_comercial === 'Todos' ? 'bold' : 'normal' }">
                            {{ c.nombre_comercial }}
                          </span>
                        </template>
                      </v-checkbox>
                    </div>

                    <!-- Tipo de Servicio -->
                    <v-row class="align-center mt-4 mb-1">
                      <v-icon class="mr-2">mdi-bus-side</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1">Tipo de Servicio</v-subheader>
                    </v-row>
                    <div
                      class="mt-n2"
                      style="
                        max-height: 200px;
                        overflow-y: auto;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        padding: 8px;
                      "
                    >
                      <v-checkbox
                        v-for="tipo in servicios"
                        :key="tipo.value"
                        :value="tipo.value"
                        v-model="filtros.servicios"
                        dense
                        hide-details
                      >
                        <template v-slot:label>
                          <span :style="{ fontWeight: tipo.value === 'Todos' ? 'bold' : 'normal' }">
                            {{ tipo.label }}
                          </span>
                        </template>
                      </v-checkbox>
                    </div>

                    <!-- Plantas -->
                    <v-row class="align-center mt-4 mb-1">
                      <v-icon class="mr-2">mdi-office-building</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1">Plantas</v-subheader>
                    </v-row>
                    <div
                      class="mt-n2"
                      style="
                        max-height: 250px;
                        overflow-y: auto;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        padding: 8px;
                      "
                    >
                      <v-checkbox
                        v-for="p in plantas"
                        :key="p.plantaid"
                        :value="p"
                        v-model="filtros.plantas"
                        dense
                        hide-details
                      >
                        <template v-slot:label>
                          <span :style="{ fontWeight: p.nombre_planta === 'Todos' ? 'bold' : 'normal' }">
                            {{ p.nombre_planta }}
                          </span>
                        </template>
                      </v-checkbox>
                    </div>

                    <!-- Turnos -->
                    <v-row class="align-center mt-4 mb-2">
                      <v-icon class="mr-2">mdi-pound</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1">Turnos</v-subheader>
                    </v-row>
                    <v-btn-toggle v-model="filtros.turnos" multiple class="d-flex flex-wrap" style="width: 100%">
                      <v-btn
                        v-for="n in 5"
                        :key="n"
                        :value="n"
                        class="ma-1 flex-grow-1"
                        :color="filtros.turnos.includes(n) ? 'primary' : 'white'"
                        :class="{ 'white--text': filtros.turnos.includes(n) }"
                        style="min-width: 48px; max-width: 64px"
                      >
                        {{ n }}
                      </v-btn>
                    </v-btn-toggle>
                    <div class="mt-2 caption grey--text">Selecciona los turnos que deseas mostrar</div>
                  </v-col>

                  <!-- Columna 2 -->
                  <v-col cols="12" md="6">
                    <!-- Horas Futuro -->
                    <v-row class="align-center mb-1">
                      <v-icon class="mr-2">mdi-timer-outline</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1">Horas de Viaje a Futuro</v-subheader>
                    </v-row>
                    <div class="mt-1">
                      <div class="d-flex align-center mt-1">
                        <span
                          class="mr-3 grey--text text-caption font-weight-bold"
                          style="width: 30px; text-align: left"
                          >1h</span
                        >
                        <v-slider v-model="filtros.horasFuturo" min="1" max="96" step="1" class="flex-grow-1" />
                        <span
                          class="ml-3 grey--text text-caption font-weight-bold"
                          style="width: 30px; text-align: right"
                          >96h</span
                        >
                      </div>
                      <div
                        class="text-center font-weight-bold"
                        style="color: var(--v-primary-base); margin-top: -25px; margin-bottom: 15px"
                      >
                        {{ filtros.horasFuturo }} h
                      </div>
                      <v-text-field solo v-model="filtros.horasFuturo" type="number" hide-details dense />
                    </div>
                    <div class="text-caption" style="margin-top: 10px">
                      Mostrar viajes programados hasta {{ filtros.horasFuturo }} horas en el futuro
                    </div>

                    <!-- Intervalo Actualización -->
                    <v-row class="align-center mb-1 mt-8">
                      <v-icon class="mr-2">mdi-clock-time-four-outline</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1"
                        >Intervalo de Actualización</v-subheader
                      >
                    </v-row>
                    <v-container fluid class="pa-0">
                      <v-row dense>
                        <v-col cols="4" v-for="(t, i) in tiempos" :key="t.value">
                          <v-btn
                            :value="t.value"
                            @click="filtros.intervaloActualizacion = t.value"
                            :color="filtros.intervaloActualizacion === t.value ? 'primary' : 'white'"
                            class="ma-1"
                            block
                          >
                            {{ t.label }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-text-field
                      v-model="filtros.intervaloPersonalizado"
                      type="number"
                      dense
                      persistent-hint
                      hint="Mínimo: 1 segundo (1000ms) - Máximo: 5 minutos (300000ms)"
                      style="margin-top: 50px"
                    >
                      <template v-slot:label>
                        <span style="font-size: 1.3rem; font-weight: bold">Personalizado (ms)</span>
                      </template>
                    </v-text-field>

                    <!-- Intervalo Cambio Pagina -->
                    <v-row class="align-center mb-1 mt-2">
                      <v-icon class="mr-2">mdi-clock-time-four-outline</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1"
                        >Intervalo cambio de Página</v-subheader
                      >
                    </v-row>
                    <v-text-field
                      v-model="filtros.intervaloPagina"
                      type="number"
                      dense
                      persistent-hint
                      hint="Mínimo: 1 segundo (1000ms) - Máximo: 5 minutos (300000ms)"
                      style="margin-top: 15px"
                    >
                      <template v-slot:label>
                        <span style="font-size: 1.3rem; font-weight: bold">Personalizado (ms)</span>
                      </template>
                    </v-text-field>

                    <!-- Vaijes por tabla -->
                    <v-row class="align-center mb-1 mt-2">
                      <v-icon class="mr-2">mdi-reorder-horizontal</v-icon>
                      <v-subheader class="pa-0 font-weight-bold text-subtitle-1">Viajes por tabla</v-subheader>
                    </v-row>
                    <v-text-field
                      v-model="itemsPerTable"
                      type="number"
                      dense
                      persistent-hint
                      hint=""
                      style="margin-top: 20px"
                    >
                      <template v-slot:label>
                        <span style="font-size: 1.3rem; font-weight: bold">Personalizado</span>
                      </template>
                    </v-text-field>

                    <!-- Resumen -->
                    <v-subheader class="pa-0 font-weight-bold text-subtitle-1" style="margin-top: 0px"
                      >Resumen de Configuración:</v-subheader
                    >
                    <v-card outlined dense class="pa-2">
                      <v-row dense no-gutters v-for="(item, i) in resumen" :key="i" class="py-1">
                        <v-col cols="6" class="text-left">{{ item.label }}</v-col>
                        <v-col
                          cols="6"
                          class="text-right font-weight-bold"
                          :class="{ 'primary--text': item.esPrimario }"
                        >
                          {{ item.valor }}
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>

            <v-divider class="mt-2" />

            <!-- Footer fijo -->
            <v-card-actions class="pa-4">
              <!-- IZQUIERDA: Texto arriba, URL + copiar abajo -->
              <v-col class="d-flex flex-column" cols="auto">
                <span class="font-weight-medium mb-2">Acceso sin intervención:</span>

                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <v-text-field
                      v-model="urlGenerada"
                      dense
                      readonly
                      hide-details
                      class="campo-pequeno"
                      style="width: 500px"
                      placeholder="Se generará al abrir"
                    />
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center">
                    <!-- Botón copiar -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="copiarUrl" :disabled="!urlGenerada" v-bind="attrs" v-on="on">
                          <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>

                    <!-- Botón regenerar -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="regenerarToken" v-bind="attrs" v-on="on">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      <span>Regenerar Token</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>

              <v-spacer></v-spacer>

              <!-- DERECHA: Botones de acción -->
              <v-btn text @click="show = false">Cancelar</v-btn>
              <v-btn color="primary" @click="aplicarFiltros">
                <v-icon left>mdi-content-save-outline</v-icon>
                Aplicar Filtros
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-container>
  </v-main>
</template>

<script>
import { infoChip } from '@/components'
import services from '@/utils/services'

const DEFAULT_INTERVAL_DATA = 60000 * 2
const DEFAULT_INTERVAL_PAGE = 3000
export default {
  name: 'Dashboard',
  props: {
    value: Boolean
  },
  components: {
    infoChip
  },

  data: () => ({
    dialog: false,
    intervalId: null,
    intervalIdActualizacion: null,
    currentPage: 1,
    loading: false,
    urlGenerada: '',
    requestBody: {},
    headers: [
      { text: 'HORA SALIDA', value: 'horaSalida', width: '10px' },
      { text: 'RUTA', value: 'ruta', width: '10px' },
      { text: 'VEHÍCULO', value: 'vehiculo', width: '10px' },
      { text: 'TIEMPO PARA SALIR', value: 'tiempoParaSalir', width: '10px' }
    ],
    items: [],
    show: false,
    clientes: [],
    plantas: [],
    defaultIntervaloActualizacion: 60000 * 2,
    servicios: [
      { label: 'Todos', value: 'Todos' },
      { label: 'Mete', value: 'M' },
      { label: 'Saca', value: 'S' },
      { label: 'Van', value: 'V' }
    ],
    tiempos: [
      { label: '3 seg', value: 3000 },
      { label: '5 seg', value: 5000 },
      { label: '10 seg', value: 10000 },
      { label: '15 seg', value: 15000 },
      { label: '30 seg', value: 30000 },
      { label: '2 min', value: DEFAULT_INTERVAL_DATA }
    ],
    itemsPerTable: 12,
    filtros: {
      token: null,
      clientes: [],
      servicios: ['S'],
      turnos: [],
      plantas: [],
      horasFuturo: 12,
      intervaloActualizacion: DEFAULT_INTERVAL_DATA,
      intervaloPersonalizado: 5000,
      intervaloPagina: DEFAULT_INTERVAL_PAGE,
      itemsPerTable: 12
    }
  }),
  async mounted() {
    await this.start()
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
    clearInterval(this.intervalIdActualizacion)
  },
  computed: {
    isClienteDeparturesAuth() {
      return this.$route.name == 'clientDeparturesAuth'
    },
    isReading: function () {
      return services.check(1, this.$route.path)
    },
    visibleItems() {
      const start = (this.currentPage - 1) * this.filtros.itemsPerTable * 2
      const end = start + this.filtros.itemsPerTable * 2
      return this.items.slice(start, end)
    },
    firstTableItems() {
      return this.visibleItems.slice(0, this.filtros.itemsPerTable)
    },
    secondTableItems() {
      return this.visibleItems.slice(this.filtros.itemsPerTable, this.filtros.itemsPerTable * 2)
    },
    totalPages() {
      return Math.ceil(this.items.length / (this.filtros.itemsPerTable * 2))
    },
    rowSize() {
      return 66
    },
    tableHeight() {
      const alturaCalculada = 56 + this.filtros.itemsPerTable * this.rowSize
      return Math.max(alturaCalculada, 120) + 'px'
    },
    displayedItems() {
      const totalMostrados = this.items.slice(
        (this.currentPage - 1) * this.filtros.itemsPerTable * 2,
        this.currentPage * this.filtros.itemsPerTable * 2
      )
      return totalMostrados.length
    },
    intervaloTexto() {
      const tiempoEncontrado = this.tiempos.find((t) => t.value === this.filtros.intervaloActualizacion)
      const esPersonalizado = !tiempoEncontrado
      if (esPersonalizado) {
        return `${this.filtros.intervaloPersonalizado} ms`
      }
      return tiempoEncontrado.label
    },
    intervaloPaginaTexto() {
      return `${this.filtros.intervaloPagina / 1000} seg`
    },
    resumenClientes() {
      const seleccionados = this.filtros.clientes
      if (seleccionados.some((c) => c.nombre_comercial === 'Todos')) {
        return 'Todos'
      }
      if (seleccionados.length === 0) {
        return 'Ninguno'
      }
      return `${seleccionados.length} Seleccionados`
    },
    resumenServicios() {
      const sel = this.filtros.servicios

      if (!sel || sel.length === 0) {
        return 'Ninguno'
      }

      if (sel.includes('Todos')) {
        return 'Todos'
      }

      return `${sel.length} Seleccionados`
    },
    resumenPlantas() {
      const sel = this.filtros.plantas

      if (!Array.isArray(sel) || sel.length === 0) return 'Ninguno'

      if (sel[0]?.nombre_planta === 'Todos') return 'Todos'

      return `${sel.length} Seleccionadas`
    },
    resumen() {
      return [
        { label: 'Clientes:', valor: this.resumenClientes },
        { label: 'Servicios:', valor: this.resumenServicios },
        { label: 'Plantas:', valor: this.resumenPlantas },
        { label: 'Turnos:', valor: this.filtros.turnos.length ? this.filtros.turnos.join(', ') : 'Todos' },
        { label: 'Horas futuro:', valor: `${this.filtros.horasFuturo}h` },
        { label: 'Actualización:', valor: this.intervaloTexto, esPrimario: true },
        { label: 'Cambio de Página:', valor: `${this.filtros.intervaloPagina / 1000} seg`, esPrimario: true },
        { label: 'Viajes por Tabla:', valor: this.itemsPerTable, esPrimario: true }
      ]
    }
  },
  watch: {
    value(val) {
      this.show = val
    },
    show(val) {
      this.$emit('input', val)
      if (val) {
        this.generarUrl()
        this.axios.post(services.routes.clientDeparturesSettings, this.filtros)
        // Cuando se abre el modal
        if (this.filtros.clientes.length === 0) {
          this.filtros.clientes = [{ idcliente_externo: 0, nombre_comercial: 'Todos' }]
        }
        if (this.filtros.servicios.length === 0) {
          this.filtros.servicios = ['Todos']
        }

        if (!this.filtros.plantas || this.filtros.plantas.length === 0) {
          this.filtros.plantas = [{ plantaid: '0', nombre_planta: 'Todos' }]
        }
        if (!this.filtros.intervaloActualizacion) {
          if (!this.filtros.intervaloPersonalizado) {
            this.filtros.intervaloActualizacion = DEFAULT_INTERVAL_DATA
          }
        }
        if (!this.filtros.servicios) {
          this.filtros.servicios = ['S']
        }
      }
    },
    'filtros.intervaloPersonalizado'(nuevoValor) {
      if (!this.tiempos.some((t) => t.value === Number(nuevoValor))) {
        this.filtros.intervaloActualizacion = null
      }
    },
    'filtros.clientes'(nuevo, viejo) {
      const clienteTodos = this.clientes.find((c) => c.nombre_comercial === 'Todos')
      const idTodos = clienteTodos?.idcliente_externo
      const agregados = nuevo.filter((n) => !viejo.some((v) => v.idcliente_externo === n.idcliente_externo))
      // Si se seleccionó "Todos"
      if (agregados.some((c) => c.idcliente_externo === idTodos)) {
        this.filtros.clientes = [clienteTodos]
        return
      }
      // Si estaba seleccionado "Todos" y se agregó otro cliente
      if (viejo.some((c) => c.idcliente_externo === idTodos) && agregados.length) {
        this.filtros.clientes = nuevo.filter((c) => c.idcliente_externo !== idTodos)
        return
      }
      // Si se quitó todo, volver a seleccionar "Todos"
      if (nuevo.length === 0) {
        this.filtros.clientes = [clienteTodos]
      }
    },
    'filtros.servicios'(nuevo, viejo) {
      const agregados = nuevo.filter((c) => !viejo.includes(c))
      if (agregados.includes('Todos')) {
        this.filtros.servicios = ['Todos']
        return
      }
      if (viejo.includes('Todos') && agregados.length) {
        this.filtros.servicios = nuevo.filter((c) => c !== 'Todos')
        return
      }
      if (nuevo.length === 0) {
        this.filtros.servicios = ['Todos']
      }
    },
    'filtros.plantas'(nuevo, viejo) {
      if (!Array.isArray(nuevo)) return

      const plantaTodos = this.plantas.find((p) => p.nombre_planta === 'Todos')
      if (!plantaTodos) return

      const idTodos = plantaTodos.plantaid
      const agregados = nuevo.filter((n) => !viejo.some((v) => v.plantaid === n.plantaid))

      // Seleccionó "Todos"
      if (agregados.some((p) => p.plantaid === idTodos)) {
        this.filtros.plantas = [plantaTodos]
        return
      }

      // Si estaba "Todos" y agregó otro
      if (viejo.some((p) => p.plantaid === idTodos) && agregados.length) {
        this.filtros.plantas = nuevo.filter((p) => p.plantaid !== idTodos)
        return
      }

      // Si quitó todo
      if (nuevo.length === 0) {
        this.filtros.plantas = [plantaTodos]
      }
    }
  },
  methods: {
    getHora(fecha) {
      return fecha.split(' ')[1]
    },
    getFecha(fecha) {
      const [dia, mes] = fecha.split(' ')[0].split('-')
      return `${dia}/${mes}`
    },
    async getClientes() {
      this.clientes = [{ idcliente_externo: 0, nombre_comercial: 'Todos' }]
      this.axios
        .get(services.routes.clients)
        .then((res) => {
          this.clientes = this.clientes.concat(res.data.data)
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response.data.code
        })
    },
    async getPlantas() {
      this.plantas = [{ plantaid: '0', nombre_planta: 'Todos' }]
      this.axios
        .get(services.routes.clientDeparturesPlantas)
        .then((res) => {
          this.plantas = this.plantas.concat(res.data)
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response.data.code
        })
    },
    async start() {
      this.loading = true
      try {
        if (this.$route.name == 'clientDeparturesAuth') {
          const token = this.$route.query.token
          if (!token) {
            this.$router.push({ name: 'login' })
          }
          const data = await this.axios.post(services.routes.clientDeparturesAuth, { token })
          this.filtros = data.data.filtros
          this.items = data.data.data
          this.arrancarRotacionPagina()
          this.arrancarIntervaloActualizacionToken()
        } else {
          const settings = await this.axios.get(services.routes.clientDeparturesSettings)
          await this.getClientes()
          await this.getPlantas()

          if (!settings.data) {
            this.setDefaultRequestData()
            const res2 = await this.axios.post(services.routes.clientDepartures, this.requestBody)
            this.items = res2.data
            this.arrancarRotacionPagina()
            this.arrancarIntervaloActualizacion()
          } else {
            this.filtros = settings.data.data.data
            this.createRequestFromFilters()
            const res2 = await this.axios.post(services.routes.clientDepartures, this.requestBody)
            this.items = res2.data
            if (!this.filtros.intervaloActualizacion) {
              this.filtros.intervaloActualizacion = this.filtros.intervaloPersonalizado
            }
            this.itemsPerTable = this.filtros.itemsPerTable
            this.arrancarRotacionPagina()
            this.arrancarIntervaloActualizacion()
          }
        }
      } catch (error) {
        this.error = true
        this.codeError = error.response?.data?.code
      } finally {
        this.loading = false
      }
    },
    refreshToken() {
      this.loading = true
      //clearInterval(this.intervalId)
      clearInterval(this.intervalIdActualizacion)
      this.axios
        .post(services.routes.clientDeparturesAuth, { token: this.filtros.token })
        .then((res) => {
          this.filtros = res.data.filtros
          this.items = res.data.data
          //this.currentPage = 1
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response.data.code
        })
        .finally(() => {
          this.loading = false
          this.arrancarRotacionPagina()
          this.arrancarIntervaloActualizacionToken()
        })
    },
    refresh() {
      this.loading = true
      //clearInterval(this.intervalId)
      clearInterval(this.intervalIdActualizacion)
      this.axios
        .post(services.routes.clientDepartures, this.requestBody)
        .then((res) => {
          this.items = res.data
          //this.currentPage = 1
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response.data.code
        })
        .finally(() => {
          this.loading = false
          this.arrancarRotacionPagina()
          this.arrancarIntervaloActualizacion()
        })
    },
    arrancarRotacionPagina() {
      if (this.intervalId) return; //clearInterval(this.intervalId)

      this.intervalId = setInterval(() => {
        if (this.totalPages > 0) {
          this.currentPage = this.currentPage >= this.totalPages ? 1 : this.currentPage + 1
        }
      }, this.filtros.intervaloPagina)
    },
    arrancarIntervaloActualizacion() {
      if (this.intervalIdActualizacion) clearInterval(this.intervalIdActualizacion)
      this.intervalIdActualizacion = setInterval(() => {
        this.refresh()
      }, this.filtros.intervaloActualizacion)
    },
    arrancarIntervaloActualizacionToken() {
      if (this.intervalIdActualizacion) clearInterval(this.intervalIdActualizacion)
      this.intervalIdActualizacion = setInterval(() => {
        this.refreshToken()
      }, this.filtros.intervaloActualizacion)
    },
    setDefaultRequestData() {
      this.filtros.intervaloPagina = DEFAULT_INTERVAL_PAGE
      this.filtros.intervaloActualizacion = DEFAULT_INTERVAL_DATA
      this.requestBody = {
        horas_futuro: 12,
        tipos_viaje: ['S']
      }
    },
    createRequestFromFilters() {
      this.requestBody = {
        turno_id: this.filtros.turnos,
        horas_futuro: this.filtros.horasFuturo,
        tipos_viaje: this.filtros.servicios,
        ids_clientes: this.filtros.clientes?.map((c) => c.idcliente_externo) ?? [],
        ids_plantas: this.filtros.plantas?.map((p) => p.plantaid) ?? []
      }
      if (this.filtros.servicios[0] == 'Todos') {
        delete this.requestBody.tipos_viaje
      }
      if (this.filtros.turnos.length == 0) {
        delete this.requestBody.turno_id
      }

      if (!this.filtros.clientes || this.filtros.clientes[0]?.nombre_comercial === 'Todos') {
        delete this.requestBody.ids_clientes
      }
      if (!this.filtros.plantas || this.filtros.plantas[0]?.nombre_planta === 'Todos') {
        delete this.requestBody.ids_plantas
      }

      if (!this.filtros.intervaloActualizacion) {
        this.filtros.intervaloActualizacion = this.filtros.intervaloPersonalizado
      }
    },
    aplicarFiltros() {
      this.createRequestFromFilters()
      this.axios.post(services.routes.clientDeparturesSettings, this.filtros)
      if (this.itemsPerTable) {
        this.filtros.itemsPerTable = this.itemsPerTable
      }
      this.refresh()
      this.show = false
    },
    generarUrl() {
      const base = window.location.origin
      if (!this.filtros.token) {
        this.filtros.token = crypto.randomUUID()
      }
      const params = new URLSearchParams({ token: this.filtros.token })
      this.urlGenerada = `${base}/client/departures/auth?${params.toString()}`
    },
    regenerarToken() {
      this.filtros.token = null
      this.generarUrl()
      this.axios.post(services.routes.clientDeparturesSettings, this.filtros)
    },
    copiarUrl() {
      if (!this.urlGenerada) return
      navigator.clipboard.writeText(this.urlGenerada).then(() => {})
    }
  }
}
</script>

<style scoped>
.custom-header-color >>> thead {
  background-color: #000000;
}

.custom-header-color >>> thead tr:first-child th:first-child {
  border-top-left-radius: 12px;
}

.custom-header-color >>> thead tr:first-child th:last-child {
  border-top-right-radius: 12px;
}

.custom-header-color >>> thead th {
  color: white !important;
  font-size: 20px !important; /*aplica*/
  font-weight: bold !important; /* 🔹 Negrita */
}

.custom-header-color >>> thead th {
  color: white !important;
  text-align: center !important;
}

.custom-header-color >>> tbody td {
  text-align: center !important;
  font-size: 18px !important; /*aplica*/
}

.v-btn--example {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
}

.white--background {
  background-color: white !important;
  color: #000 !important;
}

@keyframes glow-pulse {
  0% {
    box-shadow: 0 0 6px 2px rgba(76, 175, 80, 0.3);
  }

  50% {
    box-shadow: 0 0 12px 4px rgba(14, 109, 124, 0.8);
  }

  100% {
    box-shadow: 0 0 6px 2px rgba(76, 175, 80, 0.3);
  }
}

::v-deep(.campo-pequeno input) {
  font-size: 14px !important;
}

.glow-en-ruta {
  animation: glow-pulse 1.2s ease-in-out infinite;
}
</style>
